import React from "react";
import { IProduct, IVariant } from "../../models/product.interface";
import {
  Button,
  Icon,
  Divider,
  Container,
  Header,
    Image
} from "semantic-ui-react";
import _ from "lodash";
import ToolTip from "../shared/ToolTip";
import DownloadIcon from "../../resources/images/download.png";

interface IState {
  selectedVariant: IVariant | null;
  selectedDuration: number;
  selectedRentalAmount: number;
  hiddenCss: {};
}


interface IProps {
  product: IProduct;
  products: IProduct[];
  onAddToBasket(product: IProduct, variant: IVariant): void;
  onRemoveFromBasket(product: IProduct): void;
  isProductInSameExlusivityGroup: boolean;
  isProductSelected: boolean;
}

export class ProductContainer extends React.Component<IProps, IState> {
  state: IState = {
    selectedVariant: null,
    selectedDuration: 0,
    selectedRentalAmount: 0,
    hiddenCss: { display: "none" }
  };
  constructor(props: IProps) {
    super(props);
    let variantsGroupedByDuration = _.chain(this.props.product.variants)
      .sortBy("rentalAmount")
      .groupBy("duration")
      .map((value, key) => ({ duration: key, variants: value }))
      .value();

    this.state.selectedDuration = parseInt(
      variantsGroupedByDuration[0].duration
    );

    let variantsGroupedByRentalAmount = _.chain(this.props.product.variants)
      .groupBy("rentalAmount")
      .map((value, key) => ({ rentalAmount: key, variants: _.sortBy(value, "duration") }))
      .value();

    this.state.selectedRentalAmount = parseInt(
      variantsGroupedByRentalAmount[0].rentalAmount
    );

    if (this.hasMonthlyRentalVariants(this.props.product.variants)) {
      this.state.selectedVariant = variantsGroupedByRentalAmount[0].variants[0];
    } else {
      this.state.selectedVariant = variantsGroupedByDuration[0].variants[0];
    }

    //console.log(variantsGroupedByRentalAmount);
    //console.log(this.state.selectedVariant);
  }

  renderExclusivity = (func: (x:string) => React.ReactNode) : React.ReactNode => {

    const otherProducts : Array<IProduct> = this.props.products.filter(p => p.exclusivityGroup === this.props.product.exclusivityGroup && p.productCode !== this.props.product.productCode);
    if (otherProducts && otherProducts.length > 0) {
      
      return func(otherProducts[0].productDisplayName);
    }
    return <span/>;
  }

  getSnapshotBeforeUpdate(prevProps: IProps, prevState: any) {
    return null;
  }

  componentDidUpdate(prevProps: IProps, prevState: IState, snapshot: any) {}

  renderProductDurationVariants = (variants: IVariant[]) => {
    let variantsGroupedByDuration = _.chain(variants)
      .groupBy("duration")
      .map((value, key) => ({ duration: key, variants: value }))
      .value();

    let key = 0;
    return variantsGroupedByDuration.map(v => (
      <span key={key++}>
        <Button
          className={
            this.state.selectedDuration === parseInt(v.duration)
              ? "primary"
              : ""
          }
          onClick={async (event: any) => {

            event.preventDefault();
            let duration = parseInt(v.duration);
            let newState = {selectedDuration: duration, selectedVariant: this.state.selectedVariant};
            if (this.state.selectedVariant) {
              //console.log(newState.selectedVariant.rentalAmount);
              let index = _.findIndex(v.variants, { duration: duration, rentalAmount: this.state.selectedVariant.rentalAmount });
              if (index > -1) {
                newState = {...newState, selectedVariant: v.variants[index]};
              }

              if (newState.selectedVariant != null) {
                //console.log(`price: ${newState.selectedVariant.rentalAmount}, duration: ${newState.selectedVariant.duration}`);
              }
            
              this.setState(newState);
            }

          }}
        >
          {v.duration} Months
        </Button>
      </span>
    ));
  };

  hasMonthlyRentalVariants = (variants: IVariant[]) => {
    let filtered = _.filter(variants, v => {
      return v.rentalAmount !== null;
    });

    if (filtered.length > 0) return true;
    else return false;
  };

  renderMonthlyRentalVariants = (
    selectedDuration: number,
    variants: IVariant[]
  ) => {
    //Filter out the variants with null rental amount and selected duration
    let filtered = _.filter(variants, v => {
      return v.rentalAmount !== null && v.duration === selectedDuration;
    });

    let key = 0;

    if (filtered.length === 0) return <></>;

    let sortedvariants = _.sortBy(filtered, [
      function(o) {
        return o.rentalAmount;
      }
    ]);

    return sortedvariants.map(v => (
      <span key={key++}>
        <Button
          className={
            this.state.selectedRentalAmount === v.rentalAmount ? "primary" : ""
          }
          onClick={(event: any) => {
            event.preventDefault();
            //this.setState({ selectedRentalAmount: v.rentalAmount });

            if (this.hasMonthlyRentalVariants(variants)) {
              //this.setState({ selectedVariant: v });
              this.setState({ selectedRentalAmount: v.rentalAmount, selectedVariant: v });
             // console.log(v)
            } else {
              this.setState({ selectedRentalAmount: v.rentalAmount });
            }
          }}
        >
          £{v.rentalAmount}
        </Button>
      </span>
    ));
  };

  render() {
    let monthlyRentalQuestion;
    if (this.hasMonthlyRentalVariants(this.props.product.variants)) {
      monthlyRentalQuestion = (
        <>
          <label>What is the monthly rental amount?</label>
        </>
      );
    }

    return (
        <>
        <Container className="b2c__card hasFooter">
          <Container className="b2c__cardHasFooterTop">
            <div className="row">
                <div>
                    <Header as="h3">
                        {this.props.product.productDisplayName}
                    </Header>
                </div>
                {
                    /* <div>
                    <ToolTip cssClasses="" outerCssClasses="text-tip">
                        
                        <div
                            dangerouslySetInnerHTML={{
                                __html: this.props.product.metadata.popupHtml
                            }}
                        ></div>
                        <Divider hidden />
                        <a
                            className="ui button primary"
                            href={this.props.product.metadata.keyFactsUrl}
                            target="_blank"
                            rel="noreferrer"
                        >
                            IPID
    </a>
    &nbsp;
    <a
                            className="ui button primary"
                            href={this.props.product.metadata.policyWordingUrl}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Policy Wording
    </a>
                    </ToolTip>
                </div>
                */
        }
            </div>
            {this.props.product.metadata.productInfoHtml && <div className="productContainerRow">
              <div dangerouslySetInnerHTML={{
                                __html: this.props.product.metadata.productInfoHtml
               }}></div>
              <div className="downloadSection">
                <div className="downloadIcon"><a
                    
                    href={this.props.product.metadata.keyFactsUrl}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Image floated="left" src={DownloadIcon} className="productContainerDownloadIcon" /> Download Policy Summary
                </a></div>
                <div className="downloadIcon">                
                <a
                    
                    href={this.props.product.metadata.policyWordingUrl}
                    target="_blank"
                    rel="noreferrer"
                >
                  <Image floated="left" src={DownloadIcon} className="productContainerDownloadIcon" />Download Policy Wording
                </a>
                </div>
                <div className="downloadIcon">
                    <a

                        href="https://www.alanboswell.com/wp-content/uploads/ABG-terms-of-business.pdf"
                        target="_blank"
                        rel="noreferrer"
                    >
                      <Image floated="left" src={DownloadIcon} className="productContainerDownloadIcon" />Download Terms Of Business
                    </a>
                </div>
              </div>
            </div>}
            {this.props.product.variants.length > 1 && <React.Fragment>
              <Divider hidden />
              <Divider hidden />
              <label>How long do you want this cover to last?</label>
              {this.renderProductDurationVariants(this.props.product.variants)}
              <Divider hidden />
              {monthlyRentalQuestion}
              {this.renderMonthlyRentalVariants(
                this.state.selectedDuration,
                this.props.product.variants
              )}
            </React.Fragment>}
            { false && <Divider hidden />}
            {false && this.renderExclusivity((name)=><p>*Not available with {name}</p>)}
          </Container>
          <Container className="coverFooter">
            <div
              style={this.props.isProductSelected ? this.state.hiddenCss : {}}
            >
              <Button
                positive
                onClick={async (event: any) => {
                  event.preventDefault();

                  if (this.state.selectedVariant === null) return;

                  this.props.onAddToBasket(
                    this.props.product,
                    this.state.selectedVariant
                  );

                  //await this.setState({ isProductSelected: true });
                }}
              >
                <Icon name="plus circle" size="large"></Icon>
                <span> Add to basket</span>
              </Button>
            </div>
            <div
              style={this.props.isProductSelected ? {} : this.state.hiddenCss}
            >
              <Button
                onClick={async (event: any) => {
                  event.preventDefault();

                  await this.props.onRemoveFromBasket(this.props.product);
                  // await this.setState({ isProductSelected: false });
                }}
              >
                <Icon name="minus circle" size="large"></Icon>
                <span> Remove from basket</span>
              </Button>
            </div>
            <div className="floatRight coverPrice">
              <Header as="h3">
                Total £
                {this.state.selectedVariant
                  ? this.state.selectedVariant.total.toFixed(2)
                  : "0.00"}
              </Header>
              <span className="coverPremiumIPT">
                Premium £
                {this.state.selectedVariant
                  ? this.state.selectedVariant.nett.toFixed(2)
                  : "0.00"}
                &nbsp; + IPT £
                {this.state.selectedVariant
                  ? this.state.selectedVariant.ipt.toFixed(2)
                  : "0.00"}
              </span>
            </div>
          </Container>
        </Container>
      </>
    );
  }
}

export default ProductContainer;
